document.addEventListener('DOMContentLoaded', () => {
  // Select the visible content wrapper, as the section container might collapse
  const announcementBar = document.querySelector('.utility-bar') || document.querySelector('.announcement-bar-section');
  if (!announcementBar) return;

  const updateHeaderPosition = () => {
    try {
      const rect = announcementBar.getBoundingClientRect();
      const height = rect.height;
      
      // Check positioning style
      const style = window.getComputedStyle(announcementBar);
      const isAbsolute = style.position === 'absolute' || style.position === 'fixed';
      const isSticky = style.position === 'sticky';

      // Only update if height is valid (prevent 0px issues on scroll/hidden)
      // Only update if height is valid (prevent 0px issues on scroll/hidden)
      if (height > 0) {
          // Calculate gap
          if (isAbsolute || isSticky) {
            document.body.style.setProperty('--announcement-bar-gap', height + 'px');
          } else {
            document.body.style.setProperty('--announcement-bar-gap', '0px');
          }
      }
    } catch (e) {
      console.warn('Error calculating header position:', e);
    }
  };

  // Initial calculation
  updateHeaderPosition();

  // Observe resizing of the specific element
  const observer = new ResizeObserver(() => {
    requestAnimationFrame(updateHeaderPosition);
  });
  observer.observe(announcementBar);
  
  // Global events
  window.addEventListener('load', updateHeaderPosition);
  window.addEventListener('resize', updateHeaderPosition);

  // Check for flex slider overflow
  const checkSliderOverflow = () => {
    const flexSlider = document.querySelector('.announcement-bar-slider--flex');
    if (flexSlider) {
      const wrapper = flexSlider.closest('.announcement-bar-slider');
      if (wrapper) {
         const hasOverflow = flexSlider.scrollWidth > flexSlider.clientWidth + 5; // Add tolerance
         if (hasOverflow) {
           wrapper.classList.add('has-overflow');
           wrapper.classList.remove('no-overflow');
         } else {
           wrapper.classList.remove('has-overflow');
           wrapper.classList.add('no-overflow');
         }
      }
    }
  };

  // Run on load and resize
  checkSliderOverflow();
  window.addEventListener('resize', checkSliderOverflow);
});